import { Grid, Typography } from '@mui/material';
import { SwitchElement } from 'react-hook-form-mui';
import { FormattedMessage } from 'react-intl';

export function KeepSelectionField() {
  return (
    <>
      <Grid item xs={12} md={6}>
        <Typography>
          <FormattedMessage
            id="logger.streamScreen.screenSettings.keepSelectionOnRangeChange"
            defaultMessage="Mantener selección al cambiar el rango"
          />
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <SwitchElement name="keepSelectionOnRangeChange" label="" />
      </Grid>
    </>
  );
}
